/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import MarkdownLayout from "components/MarkdownLayout";
import JobsList from "components/JobsList";
import {getAllJobs} from "lib/localContent";
export const meta = {
  title: "Jobs",
  desc: "We're looking for passionate people to join us on our mission to revolutionize how developers experience productivity tools."
};
const MDXLayout = ({children}) => _jsx(MarkdownLayout, {
  meta: meta,
  children: children
});
export const getStaticProps = async () => {
  const jobs = getAllJobs();
  return {
    props: {
      jobs
    }
  };
};
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    h2: "h2",
    a: "a",
    ul: "ul",
    li: "li",
    strong: "strong",
    ol: "ol"
  }, props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "As builders, we optimize for output. For this, we use tools that let us achieve more with less effort. A great tool sits on the sideline, waits to be used and then gets the job done. Afterwards, it gets out of the way again. Today's workplaces are the opposite: Collaboration harms productivity, notifications scream for attention and websites are clumsy."
    }), "\n", _jsx(_components.p, {
      children: "We aim to calm this mess by providing a simple user interface that reduces tools to their core functionality. Raycast is designed to keep their users focused. It optimizes for the shortest path from intent to action without any detours. The ephemeral app is accessible from anywhere on a Mac and fully keyboard-driven."
    }), "\n", _jsx(_components.p, {
      children: "Many highly-rewarding productivity tools are custom to the setup of individuals or teams. To support such setups, we’re providing the toolkit for developers to automate their every-day tasks. On top, we're establishing a community to shape an ecosystem of productivity tools."
    }), "\n", _jsx(_components.p, {
      children: "Join our fully distributed team to make work frictionless and change how developers control, build and share their productivity tools."
    }), "\n", _jsx(_components.h2, {
      children: "Open positions"
    }), "\n", _jsx(_components.p, {
      children: "We're currently looking for the following positions:"
    }), "\n", _jsx(JobsList, {
      jobs: props.jobs
    }), "\n", _jsxs(_components.p, {
      children: ["If you resonate with our mission but there isn’t an open position for you, you can also send us an email at ", _jsx(_components.a, {
        href: "mailto:jobs@raycast.com",
        children: "jobs@raycast.com"
      }), " with any information you’d think is relevant."]
    }), "\n", _jsx(_components.h2, {
      children: "What we offer"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "We're at the beginning of our next chapter."
        }), " You will join us at the ", _jsx(_components.a, {
          href: "blog/series-a/",
          children: "right time"
        }), " to have major impact on the future of the company. We released our platform, established a friendly community and are jumping head first into expanding our product to teams."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "We're backed by great investors."
        }), " We're backed by ", _jsx(_components.a, {
          href: "https://www.accel.com/noteworthy/giving-developers-superpowers-our-investment-in-raycast",
          children: "Accel"
        }), ", Coatue, Y Combinator, Chapter One and angels such as Charlie Cheever (Co-Founder of Expo & Quora), Calvin French-Owen (Co-Founder of Segment), Zach Holman (Early GitHub engineer), Koen Bok\n(Framer, CEO), Karri Saarinen (CEO, Linear) and many more."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "We're individual contributors at heart."
        }), " We value full ownership and responsibility, choose quality over quantity and put our users first. We're motivated by shipping truly great software."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "We'll treat you well."
        }), " Get a competitive salary, equity and health insurance. Plus, we provide a monthly health benefit for a gym, pay for your coworking space, give you the latest MacBook Pro with a 5K display and accessories and provide 25 days of paid-time off (PTO) plus all national holidays."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "Application process"
    }), "\n", _jsx(_components.p, {
      children: "During our interview process, we want to make sure that both sides get a good understanding of what it feels to work together day-to-day. Our process contains a few steps:"
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Send us an engaging email."
        }), " Tell us why you want to join Raycast and why you generally care about the problem we're solving. Make your first impression count. Share with us what excites you and how you envision your role at Raycast."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "An intro call with the founders."
        }), " Both parties get to know each other. You learn more about Raycast and can ask us any question. From our side, we want to understand what motivated you to apply."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Test task."
        }), " We give you an assignment that is similar to tasks you would do on a daily basis as part of the team. We’ll create a shared Slack channel to communicate so you will get a sense of what it’s like to collaborate with the team."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "Another video call to present your task."
        }), " Time to show your work in a short video call with some of us. Expect some role-specific questions to better understand how you tick."]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "After the last step, we get back to you with a decision. In rare cases, we might ask you for another call."
    })]
  });
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
